import type { TProduct } from "@/features/billing/types";
import MyAxios from "@/utilize/MyAxios";
import { useMutation } from "@tanstack/react-query";

type TPlan = {
  products: TProduct[];
};
//post not get
export default function useGetBillingPlansList() {
  return useMutation({
    mutationFn: (currency: string) =>
      MyAxios.post<TPlan>(`/billing/get-plans/${currency}`).then(
        (res) => res.data,
      ),
  });
}
